
(function() {
  if(!window['SellerPanda'] || !window['SellerPanda']['Swatchify']){
    console.error('Swatchify error! Please contact support@sellerpanda.com')
  } else {
    window['SellerPanda']['Swatchify'].swatchify_SetSwatches({swatches: {"Fabric":{"Sky":"1","Navy":"1","Novo":"1","Black":"1","Cobra":"1","Cocoa":"c#3E2E09","Lilac":"1","Melon":"2","White":"c#FFFFFF","Yellow":"1","Emerald":"1","Giraffe":"1","Key Lime":"1","Off White":"1","Blue Crush":"1","Ribbed Black":"1","Ribbed White":"1","Daytona Floral":"1","Textured Black":"1","Sky (Pre-order)":"1","Luxe Ribbed Blue":"1","Novo (Pre-order)":"1","Beach Club Floral":"1","Faded Sporty Blue":"1","Luxe Ribbed Golden":"1"}}, specific: {}});
  }
}())
